import { nothing, render } from "lit-html";
import { getHtmlElementByClass } from "@utils/index";
import { getLocations } from '@services/xhr-service';
import { EmailTypeaheadTemplate, ProvidersListTemplate, LocationTypeaheadTemplate, LocationsListTemplate, SuggestedLocationTemplate } from "./templates";

export enum HotKeys {
  ENTER = 'Enter',
  TAB = 'Tab',
  ESCAPE = 'Escape',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp'
}

export const removeEmailProvidersList = (): void =>
  render(nothing, getHtmlElementByClass("providers-wrapper"));

export const renderEmailProvidersList = (configs: IEmailTypeaheadComponent, props: IEmailTypeaheadProps): void =>
  render(ProvidersListTemplate(configs, props), getHtmlElementByClass("providers-wrapper"));

export const renderEmailTypeaheadTemplate = (configs: IEmailTypeaheadComponent, props: IEmailTypeaheadProps): void =>
  render(EmailTypeaheadTemplate(configs, props), getHtmlElementByClass("email-typeahead-wrapper"));

export const removeLocationsList = (locationTypeaheadFor: string): void =>
  render(nothing, getHtmlElementByClass(`ts-suggested-locations-wrapper-${locationTypeaheadFor}`));

export const renderLocationsList = (state: ILocationsListTemplateState, handlers: ILocationTypeaheadEventHandlers): void =>
  render(LocationsListTemplate(state, handlers), getHtmlElementByClass(`ts-suggested-locations-wrapper-${state.locationTypeaheadFor}`));

export const renderSuggestedLocationTemplate = (suggestedLocation: string, locationTypeaheadFor: string) =>
  render(SuggestedLocationTemplate(suggestedLocation), getHtmlElementByClass(`ts-suggested-location-${locationTypeaheadFor}`));

export const removeSuggestedLocationTemplate = (locationTypeaheadFor: string): void => render(nothing, getHtmlElementByClass(`ts-suggested-location-${locationTypeaheadFor}`));

export const renderLocationTypeaheadTemplate = (props: ILocationTypeaheadProps, handlers: ILocationTypeaheadEventHandlers): void =>
  render(LocationTypeaheadTemplate(props, handlers), getHtmlElementByClass(`ts-location-typeahead-wrapper-${props.locationTypeaheadFor}`));

export async function getLocationsList(location: string, size: number): Promise<IAutocompleteLocationProvider[]> {
  const payload: ILocationtypeaheadPayload = {
    prefix: location,
    size
  };
  const response = await getLocations(JSON.stringify(payload));

  if (response.ok) {
    const locations = await response.json();

    return locations.map(({ canonicalName }: IAutocompleteLocationProvider) => ({ canonicalName }));
  }

  return [];
}